import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    template: `{{ params.value | date: format }}`,
    selector: 'bar-date-string-cell-renderer',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DatePipe]
})
/** Will render a date using the Angular common pipe */
export class BarDateStringCellRenderer implements ICellRendererAngularComp {
    protected params: ICellRendererParams;
    protected format: string;

    refresh(params: any): boolean {
        return false;
    }

    agInit(params: ICellRendererParams): void {
        this.params = params;
        this.format = (this.params as any).format;
    }
}
